import { ClassScheduleSession } from '../models/class-schedule-session';

export class ClassSchedule {
  id: string;
  classMasterId: string;
  classScheduleSessions: ClassScheduleSession[];
  startDateTime: string;
  locationId: string;
  active: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/class-schedule.ts